import VideoDialog from './VideoDialog/VideoDialog';
import ImageDialog from './ImageDialog/ImageDialog';
import TabsDialog from './TabsDialog/TabsDialog';
import GalleryDialog from './GalleryDialog/GalleryDialog';
import CrossSellGalleryDialog from './CrossSellGalleryDialog/CrossSellGalleryDialog';

export {
  VideoDialog,
  ImageDialog,
  TabsDialog,
  GalleryDialog,
  CrossSellGalleryDialog,
};
